import React from 'react';

import styles from './Sidebar.module.scss';
import Props from './Sidebar.props';

import { Content } from '@utils/index';
import { getRoute } from '@constants/routes';

import { useLocale } from '@hooks/useLocale';

const Sidebar = ({ sidebar }: Props) => {
  const locale = useLocale();

  return (
    <div className={styles.Sidebar}>
      {sidebar.elements.map((item, id) => {
        return (
          <div key={id}>
            {Content.renderSidebarElement(item, {
              newsArchiveSlug: getRoute(locale as string, 'NEWS'),
              travelstoryArchiveSlug: getRoute(locale as string, 'TRAVELSTORY_ARCHIVE'),
            })}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;
